module.exports = __webpack_public_path__ + "assets/img/logo.f1550e6e.webp";